import React from 'react';
import { PropTypes } from 'prop-types';
import { IoClose } from 'react-icons/io5';
import Modal from './Modal';
import Icon from '../Icons/Icon';

const ExportSeasonsModal = ({ data = {}, handleClose = () => {} }) => {
  return (
    <Modal isShowing={data.show} onHide={handleClose}>
      <div className="w-168 h-47 bg-vamos-white rounded-md">
        <div className="p-7">
          <h2 className="text-2xl font-bold">Export a Season</h2>
        </div>
        <div className="border-vamos-blue-gray border-b" />
        <div className="flex items-center p-7">
          <div className="flex-1 ">
            <div className="flex">
              <Icon name={data.failed ? 'file_copy' : 'description'} />
              <p className="pl-3 w-32 truncate">{data.name}</p>
            </div>
          </div>
          <div className="flex-1 absolute left-1/2 transform -translate-x-1/3">
            <div className="flex h-6 items-center">
              <div className="pr-12">
                <div className={`h-4.5 w-60 ${data.completed && !data.failed ? 'bg-vamos-green1' : 'bg-vamos-light-gray'} rounded-md overflow-hidden`}>
                  {!data.completed && (
                    <>
                      <div className="progress w-full h-full rounded-md bg-vamos-green1 left-right" />
                    </>
                  )}
                </div>
              </div>
              <div className={`flex pl-3 ${data.completed ? '' : 'invisible'}`}>
                <Icon name={data.failed ? 'circle_x' : 'checkmark'} />
              </div>
            </div>
          </div>
          <div className={`w-20 ${data.completed ? '' : 'invisible'}`}>
            <p className="font-medium text-lg ">{data.failed ? 'Failed' : 'Complete!'}</p>
          </div>
        </div>
        <button type="button"><IoClose onClick={handleClose} size={25} color="#676767" className="absolute right-3 top-5" /></button>
      </div>
    </Modal>
  );
};

ExportSeasonsModal.propTypes = {
  data: PropTypes.object,
  handleClose: PropTypes.func,
};

export default ExportSeasonsModal;
